import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from '@services/authentification.service';
import {ConfirmComponent} from '@components/popup/confirm/confirm.component';
import {MatDialog} from '@angular/material/dialog';
import {TrackingService} from '@services/tracking.service';
import {AlertService} from '@services/alert.service';
import {UserService} from '@services/user.service';

@Component({
    selector: 'app-form-delete-plan',
    templateUrl: './form-delete-plan.component.html',
    styleUrls: ['./form-delete-plan.component.scss']
})
export class FormDeletePlanComponent implements OnInit {

    url = '';
    constructor(
        public dialog: MatDialog,
        public authenticationService: AuthenticationService,
        public trackingService: TrackingService,
        private userService: UserService,
        private alertService: AlertService,
    ) {
    }

    ngOnInit(): void {
        let load = 0;

        this.url = 'https://docs.google.com/forms/d/e/1FAIpQLSfZ5Ow2nFSH2tcZQbOU3RJn9o92oKbtgna8ouPU40gxSf39WQ/viewform?embedded=true&entry.853189626=' + this.authenticationService.currentUser.email;
        document.getElementById('gform').onload = () => {
            load++;
            if (load > 1) {
                const dialogRef = this.dialog.open(ConfirmComponent, {
                    width: '600px',
                    disableClose: true,
                    data: {message: 'Vous êtes sur le point de résilier votre abonnement LyBox et de perdre tout accès aux fonctionnalités qui y sont associées. <br/> Voulez-vous continuer ?'},
                });

                dialogRef.afterClosed().subscribe(result => {
                    if (result === true) {
                        this.trackingService.cancel();
                        this.userService.cancelPlan().subscribe(invoices => {
                            this.alertService.success('Votre demande est bien enregistrée, la résiliation prendra automatiquement effet à la fin de votre échéance.');
                        }, error => {
                            this.alertService.error('une erreur est survenue, veuillez réessayer ou nous contacter si le problème persiste.');
                        });
                    }
                });
            }
        };
    }
}
